import { ActionType, ProFormInstance, ProTable } from "@ant-design/pro-components";
import { useGlobalState } from "../../components/global";
import { useEffect, useRef, useState } from "react";
import UUIDComponent from "../../components/UUIDComponent";
import { Button, Dropdown, Form, MenuProps, message, Modal, Tag, Tooltip } from "antd";
import { operatorType, payType, vipType } from "../const";
import { PlusOutlined } from "@ant-design/icons";
import configFunc from "../../config";
import { Refund } from "../components/Refund";
import { useRequest } from "ahooks";

const isApplePayType = (value: string) => value === "APPLE" || value === "APPLE_AUTO";

const formatMoney = (value: unknown) => {
    const amount = Number(value);
    return `${(Number.isFinite(amount) ? amount / 100 : 0).toFixed(2)} 元`;
};

export default function RefundRecord() {
    const { user, jsonRequest } = useGlobalState();
    const tableRef = useRef<ActionType>();
    const [form] = Form.useForm();
    useEffect(() => {
        tableRef.current?.reload();
    }, []);

    const columns: any[] = [
        {
            title: "ID",
            dataIndex: "id",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "订单号",
            dataIndex: "orderNo",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} flag={true} />
        },
        {
            title: "购买内容",
            dataIndex: "vipPkgTitle",
            align: "center",
            search: false,
            width: 120,
        },
        {
            title: "会员类型",
            dataIndex: "vipType",
            align: "center",
            search: false,
            width: 110,
            valueEnum: vipType,
        },
        {
            title: "原支付方式",
            dataIndex: "payType",
            align: "center",
            search: false,
            width: 120,
            valueEnum: payType,
        },
        {
            title: "退款金额",
            dataIndex: "totalAmount",
            align: "center",
            search: false,
            render: (text: number) => formatMoney(text),
        },
        {
            title: "业务类型",
            dataIndex: "businessType",
            align: "center",
            search: false,
            valueEnum: operatorType,
        },
        {
            title: "是否真实退款",
            dataIndex: "realRefundFlag",
            align: "center",
            search: false,
            render: (text: boolean) => text ? '是' : '否',
        },
        {
            title: "退款来源",
            key: "refundSource",
            align: "center",
            search: false,
            width: 130,
            render: (_: any, record: any) => {
                if (isApplePayType(record.payType)) {
                    return <Tag color="processing">App Store 回调</Tag>;
                }
                return record.realRefundFlag
                    ? <Tag color="success">支付渠道</Tag>
                    : <Tag>人工记录</Tag>;
            },
        },
        {
            title: "第三方订单号",
            dataIndex: "mchOrderNo",
            align: "center",
            search: false,
            width: 150,
            render: (value: any) => value
                ? <UUIDComponent value={value} flag={true} />
                : "-",
        },
        {
            title: "订阅协议号",
            dataIndex: "subscriptionAgreementNo",
            align: "center",
            search: false,
            width: 150,
            render: (value: any) => value
                ? <UUIDComponent value={value} flag={true} />
                : "-",
        },
        {
            title: "外部退款单号",
            dataIndex: "outRefundNo",
            align: "center",
            search: false,
        },
        {
            title: "原因",
            dataIndex: "reason",
            align: "center",
            search: false,
        },
        {
            title: "退款时间",
            dataIndex: "createAt",
            align: "center",
            search: false,
        },
        {
            title: "退款时间",
            dataIndex: "createAt",
            align: "center",
            valueType: "dateRange",
            hideInTable: true,
        },
    ];

    const [uploadLoading, setuploadLoading] = useState(false);
    const tableFormRef = useRef<ProFormInstance>();

    const items: MenuProps['items'] = [
        {
            key: 'CURRENT_PAGE',
            label: (
                <>
                    导出此页数据
                </>
            ),
        },
        {
            key: 'ALL',
            label: (
                <>
                    导出查询数据
                </>
            ),
        },
    ];

    const newDate = (time: any) => {
        var date: Date = new Date(time)
        var y: number | string = date.getFullYear()
        var m: number | string = date.getMonth() + 1
        m = m < 10 ? '0' + m : m
        var d: any = date.getDate()
        d = d < 10 ? '0' + d : d
        return y + '-' + m + '-' + d
    }
    const [model, contextHolder] = Modal.useModal();

    // 退款
    const submitRefund = useRequest(
        (params: any) =>
            jsonRequest.post("/back/refund-record/add", {
                pwd: params.pwd,
                orderNo: params.orderNo,
                totalAmount: Math.round(Number(params.totalAmount) * 100),
                businessType: params.businessType,
                realRefundFlag: params.realRefundFlag,
                reason: params.reason,
            }),
        {
            loadingDelay: 500,
            manual: true,
            onError: (e: any) => message.error(e?.message || "退款失败"),
        },
    );


    function openRefund() {
        model.confirm({
            width: 600,
            title: "新增普通支付退款",
            content: <Refund form={form} />,
            closable: true,
            okText: "提交",
            okButtonProps: { loading: submitRefund.loading },
            async onOk() {
                const values = await form.validateFields();
                console.log(values);
                const submit: any = await submitRefund.runAsync({
                    ...values,
                });
                if (submit?.body?.code === -1) {
                    message.error(submit?.body?.msg || "退款失败");
                    return;
                }
                form.resetFields();
                message.success("退款申请成功");
                tableRef.current?.reload();
            },
        });
    }

    const clickItem = (e: any) => {
        const formFieldsValue: any = tableFormRef?.current?.getFieldsValue();
        const pageInfo: any = tableRef.current?.pageInfo;
        const { current, pageSize } = pageInfo;
        setuploadLoading(true);

        // 构建查询参数
        const params = new URLSearchParams({
            pageSize: pageSize.toString(),
            currentPage: current.toString(),
            queryBeginDate: formFieldsValue.createAt?.length ? newDate(formFieldsValue.createAt[0].$d) : "",
            queryEndDate: formFieldsValue.createAt?.length ? newDate(formFieldsValue.createAt[1].$d) : "",
            exportType: e.key
        });

        // 使用 fetch 直接下载文件
        fetch(`${configFunc.HttpEndpoint("")}/back/refund-record/export?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user?.token}`
            }
        })
            .then(response => response.blob())
            .then(blob => {
                setuploadLoading(false);
                const url = window.URL.createObjectURL(blob);
                const alink = document.createElement('a');
                alink.style.display = 'none';
                alink.href = url;
                alink.download = '退款记录.xlsx'; // 设置默认文件名
                document.body.appendChild(alink);
                alink.click();
                URL.revokeObjectURL(url);
                document.body.removeChild(alink);
            })
            .catch((err: any) => {
                console.log(err);
                setuploadLoading(false);
                message.error('导出失败');
            });
    };

    const request = async (params: any) => {
        const result: any = await jsonRequest.get("/back/refund-record/page", {
            currentPage: params.current,
            pageSize: params.pageSize,
            queryBeginDate: params?.createAt?.[0],
            queryEndDate: params?.createAt?.[1],
        }).then((resp: any) => resp.json());
        const { data } = result;
        return { data: data?.data, success: result.code === 0, total: data?.count };
    };

    return <>
        <h1>退款记录</h1>
        <ProTable
            rowKey="id"
            scroll={{ x: 1700 }}
            actionRef={tableRef}
            formRef={tableFormRef}
            cardBordered
            columns={columns}
            request={request}
            pagination={{ defaultPageSize: 10, showSizeChanger: true }}
            search={{ span: 6, defaultCollapsed: false }}
            toolBarRender={() => [
                <Tooltip key="refund-button" title="苹果订单请在 App Store Connect 发起退款">
                    <Button
                        icon={<PlusOutlined />}
                        onClick={() => openRefund()}
                        type="primary"
                    >
                        新增退款
                    </Button>
                </Tooltip>,
                <Dropdown menu={{ items, selectable: true, onClick: clickItem }} placement="bottom" arrow={{ pointAtCenter: true }}>
                    <Button loading={uploadLoading}>导出数据
                    </Button>
                </Dropdown>
            ]}
        />
        {contextHolder}
    </>;
}
